export class CarrierCompanyTrackModel {
    requestId: number;
    carrierId: number;
    trackNumber: string;
    comment: string;
}